import { ChangeEvent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedClaimInfoIndex } from '../reducers/claimSlice/claimSlice';

export type UseClaimInfoSelector = (event: ChangeEvent<HTMLInputElement>) => void;

export const useClaimInfoSelector = (): UseClaimInfoSelector => {
    const dispatch = useDispatch();
    return useCallback((event) => dispatch(setSelectedClaimInfoIndex(parseInt(event.target.value, 10))), []);
};
